// flow weak

import React, {
    PureComponent,Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import DatePicker from 'react-datepicker';
  import {addDays}  from 'material-ui/DatePicker/dateUtils';
  import TimeField from 'react-simple-timefield';
  import { Spinner } from 'react-activity';
  
  class EditCourtPricingRule extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        customer_search_list: [],
        details: {
            venue: props.match.params.id,
            starting_date:'',
            ending_date: '',
            slot_time: '',
            courts: [],
            amount: 0,
            cust_name: '',
            mobile_no: '',
            cust_mobile_no: '',
            customer_id: '',
            game_type: '',
            starting_time:'',
            ending_time:'',
            reason:3,
            discount_amount:0,
            advance_amount:0,
            reamining_amount:0,
            total_price:0,
            net_amount:0,
            selected_game:''
        },
        failed_list:[],
        game_list:[],
        message:'',
        venue_list: [],
        court_list: [],
        checkedBoxes:[],
        dayscheckedBoxes:[],
        blocked_court_list:[],
        available_court_list:[],
        court_pricing_list:[],
        isChecked: false,
        dialog_open_cust: false,
        deleteOption:false,
        search: false,
        add_Court_Price:false,
        time:'',
        new_court_price:0,
        previous_bulk_booking:'',
        blocked_for_bulk:'',
        available_for_bulk:'',
        submit_pressed:false,
        dialog_open_court_list:false,
        dialog_open_failed_list:false,
        show_booking_option:false,
        loading: true,
        selected_venue:props.match.params.id,
        new_court_size:0,
        field_type: 0,
        level:0,
        surface_type:0,
        selected_game:'',
        selected_start_day:0,
        selected_end_day:0,
        selected_start_time:'',
        selected_end_time:'',
        selected_rule_id:''
      };
      this.handleVenueChange = this.handleVenueChange.bind(this);
      this.handleGameChange = this.handleGameChange.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.getCourtPricingforVenue = this.getCourtPricingforVenue.bind(this);
      this.handleSizeChange = this.handleSizeChange.bind(this);
      this.handleDaysCheckbox = this.handleDaysCheckbox.bind(this);
      this.handleEndDayChange = this.handleEndDayChange.bind(this);
      this.handleStartDayChange = this.handleStartDayChange.bind(this);
      this.onEndTimeChange = this.onEndTimeChange.bind(this);
      this.onStartTimeChange = this.onStartTimeChange.bind(this);
      this.handleNewVenueChange = this.handleNewVenueChange.bind(this);
      this.handleNewGameChange = this.handleNewGameChange.bind(this);
      this.toconfirmdeleting = this.toconfirmdeleting.bind(this);
      this.postDeleteCourtPrice = this.postDeleteCourtPrice.bind(this);

    }
  
    componentDidMount() {
        this.getVenueList();

        
    }

    getVenueList(){
        const url = `${getLocationOrigin()}/court/get_rental_venue_for_buddy/`;
         const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => {this.setState({ venue_list: data.results},()=>{this.setData(data)})
          })
           .catch(error => error);
    }

    setData(data){
      console.log('setData')
      if(this.state.selected_venue){
        this.state.game_list = this.state.venue_list.filter(venue => venue.id == this.state.selected_venue)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      console.log(this.state.venue_list)
      console.log(this.state.game_list)
      this.setState({selected_venue:this.state.selected_venue,selected_game:this.state.game_list[0].game_id})
      this.getCourtPricingforVenue(this.state.selected_venue,this.state.venue_list.filter(venue => venue.id == this.state.selected_venue)[0].games[0].game_id)
      }
      else{
        let game_list = data.results[0].games
        let selected_venue = data.results[0].id
        let selected_game = game_list[0].game_id
        this.setState({game_list:game_list,selected_game:selected_game,selected_venue:selected_venue})
        this.getCourtPricingforVenue(selected_venue,selected_game)
      }
    }


    onEndTimeChange = time => {
        console.log(time)
        this.setState({selected_end_time:time })
    }

    onStartTimeChange = time => 
    {
      console.log(time)
      this.setState({selected_start_time:time })
    }
    
    getCourtPricingforVenue(venue_id,game){
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one['venue'] = venue_id
        new_selected_one['game_type'] = game
        console.log("getCourtPricingforVenue")
        this.setState({details: new_selected_one});
        const url = `${getLocationOrigin()}/court/getCourtPricingForVenue/?venue_id=${venue_id}&game=${game}`;
        const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({ court_pricing_list: data.results,loading:false}),
                    console.log("data")
            )
           .catch(error => error);
    }

    
    handleVenueChange(event){
      console.log(event.target.value)
     
      this.state.game_list = this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      console.log(this.state.venue_list)
      console.log(this.state.game_list)
      this.setState({selected_venue:event.target.value,selected_game:this.state.game_list[0].game_id})
      this.getCourtPricingforVenue(event.target.value,this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games[0].game_id)

      // this.getSlots(event.target.value)
    }

    handleGameChange(event){
      console.log(event.target.value)
      this.setState({selected_game:event.target.value});
      this.getCourtPricingforVenue(this.state.selected_venue,event.target.value);
    }

    handleNewVenueChange(event){
      console.log(event.target.value)
     
      this.state.game_list = this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      console.log(this.state.venue_list)
      console.log(this.state.game_list)
      this.setState({selected_venue:event.target.value,selected_game:this.state.game_list[0].game_id})
      

      // this.getSlots(event.target.value)
    }

    handleNewGameChange(event){
      console.log(event.target.value)
      this.setState({selected_game:event.target.value});
      
    }

    handleSizeChange(event){
        let name = event.target.name;
        if(name === 'size'){
          this.setState({new_court_size:event.target.value})
        }
        else if(name === 'surface_type'){
          this.setState({surface_type:event.target.value})
        }
        else if(name === 'level'){
          this.setState({level:event.target.value})
        }
        else{
          this.setState({field_type:event.target.value})
        }
    }

    handleStartDayChange(event){
      console.log(event.target.value)
      this.setState({selected_start_day:event.target.value})
    }

    handleEndDayChange(event){
      console.log(event.target.value)
      this.setState({selected_end_day:event.target.value})
    }

    handleStartDate(date){
      console.log(date)
      this.setState({selected_start_date:date});
    }

    handleEndDate(date){
      console.log(date)
      this.setState({selected_end_date:date})
    }

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.details);
        new_value[name] = event.target.value
        this.setState({details: new_value});
    }

    handleFormSubmit(event){
        event.preventDefault();
        this.check_availability(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
        // this.postBulkBooking(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes, this.props)
    }

    

    handleOpen = () => {
        this.setState({dialog_open_cust:true,dialog_open_failed_list:true});
    };

    handleDaysCheckbox = (e, s) => {
    const dayscheckedBoxes = [...this.state.dayscheckedBoxes];
    if(e.target.checked) {
        dayscheckedBoxes.push(s)
    } else {
        const index = dayscheckedBoxes.findIndex((ch) => ch.id === s.id);
        dayscheckedBoxes.splice(index, 1);
    }
    this.setState({dayscheckedBoxes:dayscheckedBoxes});
    console.log(dayscheckedBoxes)
    }
    
    handleClose = () => {
    this.setState({dialog_open_cust:false, dialog_open_court_list:false,dialog_open_failed_list:false,deleteOption:false});
    };

    updateCourtPrice(event){
      this.setState({new_court_price:event.target.value})
    }
    updateCourtSize(event){
      this.setState({new_court_size:event})
    }
    
    handleCheckbox = (e, s) => {
        const checkedBoxes = [...this.state.checkedBoxes];
        if(e.target.checked) {
            checkedBoxes.push(s)
        } else {
            const index = checkedBoxes.findIndex((ch) => ch.id === s.id);
            checkedBoxes.splice(index, 1);
        }
        this.setState({checkedBoxes:checkedBoxes});
    }

    toconfirmdeleting(id){
      this.setState({deleteOption:true,selected_rule_id:id})
    }

    postDeleteCourtPrice(){
      const url = `${getLocationOrigin()}/court/deleteCourtPricingRule/`;
      const options = {...defaultOptions};
      options['method'] = 'post'
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'court_price_id': this.state.selected_rule_id
                      });
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {                  
          alert(response.message);
          window.location.reload();
          this.setState({new_court_price:0})
          // props.history.goBack();
          })
      .catch((error) => {
          console.log(error);
          alert(error.message);
          this.setState({loading:false})
      });   
    }

    hitApplyRules() {
      const url = `${getLocationOrigin()}/court/create_pricing/?venue=${this.state.details.venue}&game=${this.state.selected_game}`;
      const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then((response) => {
            alert(response.message)
            this.setState({loading:false})
         }
          )
         .catch((error) => {
            alert(error.message)
            this.setState({loading:false})
         }
         )
    }

    applyRules() {
      this.setState({loading:true},()=>{this.hitApplyRules()})
    }

    addNewCourtPrice(){
      console.log("addNewCourtPrice")
      if(this.state.add_Court_Price){
        this.setState({add_Court_Price:false})
      }
      else{
          this.setState({add_Court_Price:true})
        }
    }
    
    postNewCourtPriceRule(){
            const url = `${getLocationOrigin()}/court/createCourtPricingRule/`;
            console.log(this.state.new_court_price)
            const options = {...defaultOptions};
            options['method'] = 'post'
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'new_court_price': this.state.new_court_price,
                                'venue':this.state.selected_venue,
                                'game':this.state.selected_game,
                                'size':this.state.new_court_size,
                                'starting_day':this.state.selected_start_day,
                                'end_day':this.state.selected_end_day,
                                'starting_time':this.state.selected_start_time,
                                'end_time':this.state.selected_end_time,
                                'field_type': this.state.field_type,
                                'surface_type': this.state.surface_type,
                                'level': this.state.level
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                alert(response.message);
                window.location.reload();
                this.setState({new_court_price:0})
                // props.history.goBack();
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });

    }

    postCourtPrice(id) {
        console.log(id)
        if(this.state.new_court_price === '' || this.state.new_court_price === 0){
            alert("Enter court price")
        }
        else{
            const url = `${getLocationOrigin()}/court/updateCourtPricingRule/`;
            console.log(this.state.new_court_price)
            const options = {...defaultOptions};
            options['method'] = 'post'
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'court_price_id': id,
                                'new_court_price': this.state.new_court_price
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                alert(response.message);
                window.location.reload();
                this.setState({new_court_price:0})
                // props.history.goBack();
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });
        }
      }

    
  
    render() {
      console.log('render')
      console.log(this.state)
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Add"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];
      const dialog_actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Delete"
          primary={true}
          onClick={this.postDeleteCourtPrice}
        />,
      ];

      const okaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleClose}
        />
      ];

      var days = [{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}]
      var SIZE_TYPE = [{id:0,name:'Default'},{id:1,name:'Five a side'},{id:2,name:'Seven a side'},{id:3,name:'Six a side'},{id:4,name:'Nine a side'}]
      var FIELD_TYPE = [{id:0,name:'Default'},{id:1,name:'Wooden'},{id:2,name:'Synthetic'},{id:3,name:'Hybrid'}]
      var SURFACE_TYPE = [{id:0,name:'Default'},{id:1,name:'Soft Surface'},{id:2,name:'Hard Surface'},{id:3,name:'Concrete'}]
      var LEVEL_TYPE = [{id:0,name:'Default'},{id:1,name:'1st Level'},{id:2,name:'2nd Level'},{id:3,name:'3rd Level'}]

      return(
        this.state.loading ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
          :
          <div style={styles.container}>
              
              <div className="col-md-8" style={{'hight':"100px",'display':"flex",'flexDirection':"row",'fontSize':"16px",}}>
                    <div className="col-md-6">Select Venue 
                    </div>
                    <div className="col-md-6" style={{'hight':"100px"}}>
                      <select name="venue" className="col-md-10" style={styles.item_body} style={{backgroundColor:'white',width:'100%'}} value={this.state.selected_venue}
                        onChange={this.handleVenueChange} disabled={this.props.match.params.id ? 'disabled': ''}>
                      {this.state.venue_list.map((venue,index) =>
                      <option key={venue.id} value={venue.id}>{venue.name}</option>
                       )} 
                      </select>
                    </div>
                    
              </div>

              <div className="col-md-8" style={{'hight':"100px",'marginTop':"5px",'fontSize':"16px",}}>
                    <div className="col-md-6">Select Game 
                    </div>
                    <div className="col-md-6" style={{'hight':"100px"}}>
                      <select name="venue" className="col-md-10" style={styles.item_body} style={{backgroundColor:'white',width:'100%'}} value={this.state.selected_game}
                        onChange={this.handleGameChange}>
                      {this.state.game_list.map((game,index) =>
                      <option key={game.game_id} value={game.game_id}>{game.game_name}</option>
                       )} 
                      </select>
                    </div>
                    
              </div>
              

            <div className='col-md-12 table_container1' style={styles.table}>
                  <div style={{'color':"#17DED7",'marginTop':"5px",'fontSize':"22px",'textAlign':"center"}}>All RULES
                  </div>
                  <div className="col-md-12" style={{'color':"#CD85F9",'marginTop':"10px",'fontSize':"15px",'textAlign':"center",display:'flex',flexDirection:'row'}}>
                              <div className="col-md-2" >
                                DAYS
                              </div>
                              <div className="col-md-2" >
                                START TIME
                              </div>
                              <div className="col-md-2" >
                                END TIME
                              </div>
                              <div className="col-md-1">
                                SIZE
                              </div>
                              <div className="col-md-1">
                                FIELD TYPE
                              </div>
                              <div className="col-md-1">
                                SURFACE
                              </div>
                              <div className="col-md-1">
                                LEVEL
                              </div>
                              <div className="col-md-1">
                                PRICE
                              </div>
                  </div>
                  <div className="col-md-12" style={{'display':"flex",'flexDirection':"column",'textAlign':"center"}}>
                  { this.state.court_pricing_list.map((court,index) =>
                    <div>
                    
                      <form  className="validated-form form-horizontal" onSubmit={this.handleFormSubmit}>
                        <div styl={{display:'flex'}}>
                             
                            <div className="col-md-12" style={{'backgroundColor':'#EBD1F9','padding':"2px",'marginTop':"2px",display:'flex',flexDirection:'row'}}>
                                
                                <div className="col-md-2" style={{'display':"flex",'flexDirection':"row",'textAlign':"center"}} >
                                  <div>
                                  { days.map((day,index)=>{return (day.id == court.starting_day && <div>{day.name}</div>) })}
                                  </div> - 
                                  <div>
                                    { days.map((day,index)=>{return (day.id == court.ending_day && <div>{day.name}</div>) })}
                                    </div>
                                </div>
                                <div className="col-md-2" >
                                  {court.start_time}
                                </div>
                                <div className="col-md-2">
                                  {court.end_time}
                                </div>
                                <div className="col-md-1" >                                
                                  {court.size}
                                </div>
                                <div className="col-md-1" >                                
                                  {court.field_type}
                                </div>
                                <div className="col-md-1" >                                
                                  {court.surface_type}
                                </div>
                                <div className="col-md-1" >                                
                                  {court.level}
                                </div>
                                
                                <div className="col-md-1" >
                                  <input type="number" style={{width:'100%'}} className="required" name="advance_amount" value={this.state.value} placeholder={court.price}
                                    onChange={(event)=>{this.updateCourtPrice(event)}}/> 
                                </div>
                                
                                <div className="col-md-1">
                                  <input type="button"  value="Update" onClick={()=>{this.postCourtPrice(court.id)}} />
                                </div>
                                <div className="col-md-1" style={{width:'5%'}}>
                                  <input type="button" style={{'backgroundColor':"red"}} value="DELETE" onClick={()=>{this.toconfirmdeleting(court.id)}} />
                                  {this.state.deleteOption &&
                                  <Dialog
                                    actions={dialog_actions}
                                    modal={false}
                                    open={this.state.deleteOption}
                                    onClick={this.handleClose}
                                    autoDetectWindowHeight={true}
                                    autoScrollBodyContent={true}
                                    scroll={scroll}
                                    dividers={scroll === 'paper'}
                                  >

                                  <div className="col-md-12">
                                    <h4 style={{textAlign:'center','color':"red"}}>Do you want to delete this rule</h4>
                                  </div>
                                  </Dialog>
                                }
                                </div>
                                
                            </div>
                            
                        </div>
                      </form>
                      
                    </div>
                  
                  )}
                  </div>
            </div>
            <div className="col-md-12" style={{'hight':"100px",'marginTop':"20px",'fontSize':"16px",'float':"center"}}>
                    <input type="button" style={{'backgroundColor':"#32b6a7",'fontSize':"18px",marginRight:'10%'}} value="Add New Rule" onClick={()=>{this.addNewCourtPrice()}} />
                    <input type="button" style={{'backgroundColor':"#32b6a7",'fontSize':"18px"}} value="Apply Rules" onClick={()=>{this.applyRules()}} />
                    {this.state.add_Court_Price && 
                    <div  style={styles.table}>
                        <form  className="validated-form form-horizontal" onSubmit={this.handleFormSubmit}>
                          <div  style={{'display':"flex",'flexDirection':"column"}}>
                              <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                  Venue
                                </div>
                                <select name="venue" className="col-md-4" style={styles.item_body} value={this.state.selected_venue}
                                  onChange={(event)=>{this.handleNewVenueChange(event)}} >
                                  {/* <option value>-------</option> */}
                                  {
                                    this.state.venue_list.map((x, index) => (
                                    <option key={x.id} value={x.id}>{x.name}</option>
                                    ))
                                  }
                                </select>
                              </div>
                              <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      Game Type
                                    </div>
                                    <select name="game_type" className="col-md-4" style={styles.item_body} value={this.state.selected_game}
                                      onChange={(event)=>{this.handleNewGameChange(event)}}>
                                      {
                                        this.state.game_list.map((x, index) => (
                                        <option key={x.game_id} value={x.game_id}>{x.game_name}</option>
                                        ))
                                      }
                                    </select>
                              </div>

                              <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                          Size 
                                    </div>
                                    <select name="size" className="col-md-4" style={styles.item_body}  value={this.state.value}
                                      onChange={this.handleSizeChange}>
                                     {SIZE_TYPE.map((size,index) =>
                                      <option key={size.id} value={size.id}>{size.name}</option>
                                     )} 
                                    </select>
                              </div>

                              <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                          Field Type 
                                    </div>
                                    <select name="field_type" className="col-md-4" style={styles.item_body}  value={this.state.value}
                                      onChange={this.handleSizeChange}>
                                     {FIELD_TYPE.map((field,index) =>
                                      <option key={field.id} value={field.id}>{field.name}</option>
                                     )} 
                                    </select>
                              </div>

                              <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                          Surface 
                                    </div>
                                    <select name="surface_type" className="col-md-4" style={styles.item_body}  value={this.state.value}
                                      onChange={this.handleSizeChange}>
                                     {SURFACE_TYPE.map((surface,index) =>
                                      <option key={surface.id} value={surface.id}>{surface.name}</option>
                                     )} 
                                    </select>
                              </div>

                              <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                          Level 
                                    </div>
                                    <select name="level" className="col-md-4" style={styles.item_body}  value={this.state.value}
                                      onChange={this.handleSizeChange}>
                                     {LEVEL_TYPE.map((level,index) =>
                                      <option key={level.id} value={level.id}>{level.name}</option>
                                     )} 
                                    </select>
                              </div>

                          
                              

                            <div style={{padding: '1%', display:'flex', flexDirection: 'row'}}>
                                  <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
                                    <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                                      Start Date
                                    </div>
                                    <select name="size" className="col-md-4" style={styles.item_body}  value={this.state.selected_start_day}
                                      onChange={this.handleStartDayChange}>
                                     {days.map((day,index) =>
                                      <option key={day.id} value={day.id} >{day.name}</option>
                                     )} 
                                    </select>
                                  </div>

                                  <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      To
                                    </div>
                                        <select name="size" className="col-md-4" style={styles.item_body}  value={this.state.selected_end_day}
                                      onChange={this.handleEndDayChange}>
                                     {days.map((day,index) =>
                                      <option key={day.id} value={day.id}>{day.name}</option>
                                     )} 
                                    </select>
                                  </div>
                            </div>
                      
                          <div style={{padding: '1%', display:'flex', flexDirection: 'row'}}>
                                  <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6" >
                                      Start Time(HH:MM:SS)
                                    </div>
                                    <TimeField value={this.state.selected_start_time} showSeconds style={styles.input} onChange={this.onStartTimeChange} />
                                  </div>
                                  <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                     To
                                    </div>
                                    <TimeField value={this.state.selected_end_time} showSeconds style={styles.input} onChange={this.onEndTimeChange} />
                                  </div>
                          </div>
                          <div className="col-md-12" style={{padding: '1%', display:'flex', flexDirection: 'row'}}>
                                <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                                      Price
                                </div>
                                <div className="col-md-4">
                                      <input type="number"  className="required" name="advance_amount" value={this.state.value} 
                                          onChange={(event)=>{this.updateCourtPrice(event)}}/> 
                                </div>
                          </div>
                          <div className="col-md-12" style={{marginTop: '10px'}}>
                              <input type="button" style={{'backgroundColor':"#32b6a7",'fontSize':"18px"}} value="Submit" onClick={()=>{this.postNewCourtPriceRule()}} />
                          </div>
                        </div>
                        </form>
                  </div>
                }
              </div>
          </div>

    );
    }
  }
  export default EditCourtPricingRule;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editCourtPricing/index.js